module.exports = __webpack_public_path__ + "7adb1a44fa7cfd65f95a45eb4eee89f3.jpg";